import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'bringozAddressCity'
})
export class BringozAddressCityPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService, @Inject('commonsService') private commonsService) {
  }

  transform(address: any, noValueEnabled?: boolean): string {
    if (address) {
      const city = _.get(address, 'city', '');
      return this.commonsService.capitalize(city);
    } else {
      return noValueEnabled ? undefined : this.translateService.instant('No Address');
    }
  }
}
